import React from 'react';
import ReactDOM from 'react-dom/client';
// Tokens first: every other stylesheet reads its colours and scales from here.
import './styles/tokens.css';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
